import { createAction } from '@reduxjs/toolkit';

import { GET_CLAIM, LOAD_CLAIM_SUMMARY } from './actionTypes';

export const loadClaimSummaryEnd = createAction(LOAD_CLAIM_SUMMARY.END);

export const getClaim = createAction(GET_CLAIM.BASE);
